<template>
  <v-footer
    dark
    height="auto"
  >
    <v-card
      class="flex"
      flat
      tile
    >
      <v-card-actions class="primary justify-center">
        {{ date }} &copy; <strong> Ashyaat<sup>®</sup></strong>
      </v-card-actions>
    </v-card>
  </v-footer>
</template>
<script>
  export default {
    data: () => ({
      date: new Date().toISOString().substr(0, 4),
    })
  }
</script>